import { memo } from "react";

import { Trans } from "react-i18next";

import UnsupportedVersionMessage from "./UnsupportedVersionMessage";

const UnsupportedBrowserVersion = ({
  browserName,
  browserVersion,
  requiredMinBrowserVersion,
  downloadPageLink,
}) => (
  <div
    className="neeto-molecules-browser-support-page"
    data-testid="browser-support-page"
  >
    <div className="neeto-molecules-browser-support-page__content">
      <h1 className="neeto-molecules-browser-support-page__header">
        <Trans i18nKey="neetoMolecules.browserSupport.unsupportedBrowserVersion.title" />
      </h1>
      <p className="neeto-molecules-browser-support-page__desc">
        <UnsupportedVersionMessage
          {...{
            browserName,
            browserVersion,
            downloadPageLink,
            requiredMinBrowserVersion,
          }}
        />
      </p>
    </div>
  </div>
);

export default memo(UnsupportedBrowserVersion);
